import {SuiModal, ComponentModalConfig, ModalSize} from "ng2-semantic-ui"
import { Component, OnInit, Input } from '@angular/core';
import { IConfirmModalContext } from '../../core/models/confirmModalcontext.interface';

interface ISimpleModalContext {
    title:string;
    question:string;
}

@Component({
    selector: 'modal-confirm',
    template: `
<div class="header">{{ modal.context.title }}</div>
<div class="content">
    <p>{{ modal.context.question }}</p>
</div>
<div class="actions">
    <button class="ui red button" (click)="modal.deny(undefined)">Close</button>
</div>
`
})
export class SimpleModalComponent {
    constructor(public modal:SuiModal<IConfirmModalContext, void, void>) {}
}
